module.exports = __webpack_public_path__ + "img/OpenBook.626956ec.svg";